<img src="/assets/images/result.png" class="nodataimg"/>
<p class="nodata">{{msg}}</p>
